import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { modulu10Validation } from '../../functions';
import { IValidationHandler, TValidatorError } from '../../model';

export function idNumberValidator(args: IValidationHandler): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const { value, invalid } = control;

    if (invalid) return null;

    if (!value) return null;

    const isValid = modulu10Validation(control.value);

    if (!isValid) {
      const vldResponse: TValidatorError = { idNumber: value };
      return vldResponse;
    }

    return null;
  };
}
